<template>
    <v-container grid-list-md fluid>
        <div v-if="companyId">
            <v-row v-if="type === 'company'">
                <v-col cols="12">
                    <EditCompany
                        :settingsMode="true"
                        :adminMode="true"
                        :companyId="companyId"
                        :showLogo="true"
                    >
                    </EditCompany>
                </v-col>
            </v-row>
            <UserTable
                v-if="type === 'users'"
                :title="'Utilisateurs'"
                :companyId="companyId"
                :mode="undefined"
                :admin="true"
            />
            <ClientCompanies v-if="type === 'clients-companies'" @refresh="refresh()" />
            <AccountingFirms
                v-if="type === 'accounting-firms'"
                :accountingFirm="company"
                @refresh="refresh()"
            />
            <AccountingWorkspaces
                v-if="type === 'accounting-workspaces'"
                :accountingFirm="company"
                @refresh="refresh()"
            />
            <AccountingPeriods v-if="type === 'accounting-period'" :companyId="companyId" />
            <BankConfig v-if="type === 'bank'" :companyId="companyId" />
            <!-- <Establishments
                v-if="type === 'establishments'"
                :company="company"
            ></Establishments> -->
            <v-row v-if="type === 'legal'">
                <v-col cols="12" class="headline"> Mentions Légales </v-col>
                <v-col cols="12">
                    <LegalForm :companyId="companyId" />
                </v-col>
            </v-row>
        </div>
        <div v-else>Pas de société</div>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import EditCompany from "../EditCompany.vue";
import UserTable from "./UserTable.vue";
import ClientCompanies from "../configuration/ClientCompanies.vue";
import AccountingFirms from "../configuration/AccountingFirms.vue";
import AccountingWorkspaces from "../configuration/AccountingWorkspaces.vue";
import AccountingPeriods from "../configuration/AccountingPeriods.vue";
import BankConfig from "../configuration/Bank.vue";
// import Establishments from "../configuration/Establishments.vue"
import LegalForm from "../configuration/LegalForm.vue";
// import ConfigAPI from "./ConfigAPI.vue";

import { Company } from "../../../../types";
import { updateStoreUser } from "../../services/userServices";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        EditCompany,
        UserTable,
        ClientCompanies,
        AccountingFirms,
        AccountingWorkspaces,
        AccountingPeriods,
        BankConfig,
        // Establishments,
        LegalForm,
        // ConfigAPI,
    },
})
export class AdminManager extends Vue {
    get companyId() {
        // debugger
        return this.$route.params.id || this.$store.state.user?.company?.id || null;
    }

    get type() {
        return this.$route.params?.type || "";
    }

    get userId() {
        return this.$store.state.user?.id || null;
    }

    @Apollo({
        query: gql`
            query CompanyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    name
                    shortName
                    siret
                    siren
                    vatNumber
                    legalForm
                    legalFormCategory
                    isActive
                    vatSystem
                    taxSystem
                    taxSystemType
                    withManager
                    vehicle
                    shop
                    salaryCount
                    shareCapital
                    registrationTown
                    users {
                        id
                        email
                    }
                    clientCompanies {
                        id
                        name
                    }
                    activities {
                        id
                        name
                        description
                    }
                    suggestions {
                        id
                        status
                        purchaseAccount {
                            id
                            type
                            name
                            description
                        }
                        salesAccount {
                            id
                            type
                            name
                            description
                        }
                        count
                    }
                    address
                    postalCode
                    city
                    country
                    accountingPeriods {
                        id
                        start
                        end
                        closed
                    }
                    salesAccounts {
                        id
                        name
                        description
                    }
                    profile {
                        id
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.companyId,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.company) {
                    this.company = data.company;
                    // if (this.company.clientCompanies) {
                    //     for (const cc of this.company.clientCompanies) {
                    //         cc.selected = false
                    //     }
                    //     console.log(this.company)
                    // } else {
                    //     this.company.clientCompanies = []
                    // }
                    if (this.company.activities) {
                        this.activities = this.company.activities.map((activity) => activity.name);
                    } else {
                        this.activities = [];
                    }

                    if (this.company.accountingPeriods) {
                        this.company.accountingPeriods = this.company.accountingPeriods.sort(
                            (a, b) => {
                                return a.start > b.start ? 1 : -1;
                            },
                        );
                    } else {
                        this.company.accountingPeriods = [];
                    }
                }
            }
        },
    })
    company: Company = {
        name: "",
        shortName: "",
        siret: "",
        siren: "",
        vatNumber: "",
        legalForm: "SAS",
        legalFormCategory: undefined,
        isActive: true,
        vatSystem: "Normal",
        taxSystem: "BIC_Normal",
        taxSystemType: "IS",
        withManager: true,
        vehicle: false,
        shop: false,
        salaryCount: 0,
        shareCapital: 0,
        registrationTown: "",
        activities: [],
        address: "",
        postalCode: "",
        city: "",
        country: "",
        // tags: [],
        clientCompanies: [],
        salesAccounts: [],
        // establishments: [],
        profile: null,
    };

    async refresh() {
        await this.$apollo.queries.company.refetch();
        setTimeout(() => updateStoreUser(this.$apollo, this.$store, this.userId), 500);
    }
}

export default toNative(AdminManager);
</script>
